/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useRef, useState} from 'react'
import {getCSS} from '../../../../_Montdor/assets/ts/_utils'
import {KTSVG} from '../../../../_Montdor/helpers'
import {Dropdown1} from '../../../../_Montdor/partials'
import {
  Get_Chart_QuotationCountApi,
  getAdminCountApi,
} from '../../../modules/dashboard-page/DashboardCRUD'
import {IAdminDashboardModel} from '../../../models/dashboard-page/IDashboardModel'
import {toast} from 'react-toastify'
import ReactApexChart from 'react-apexcharts'
import {IProjectTypeodel} from '../../../models/projects-page/IProjectsModel'
import {getAllProjectTypeMasterApi} from '../../../modules/quo-mst/QuotationMstCRUD'
import moment from 'moment'

type Props = {
  className: string
  totalCnt: any
  lablesNames: any
  selMonthID: number
  selYearID: number
}

interface IState {
  loading: boolean
  list: IProjectTypeodel
  ProjectTypeData: IProjectTypeodel[]
  options: any
  series: any
}

const StateGujaratPieChart: React.FC<Props> = ({
  className,
  totalCnt,
  lablesNames,
  selMonthID,
  selYearID,
}) => {
  const totalCount = totalCnt.reduce((sum: number, count: number) => sum + (count || 0), 0)
  const monthName =
    selMonthID > 0 && selMonthID <= 12
      ? moment()
          .month(selMonthID - 1)
          .format('MMMM')
      : 'Unknown'
  const year = selYearID > 0 ? selYearID : 'Unknown'

  const chartRef = useRef<HTMLDivElement | null>(null)

  let [state, setState] = useState<IState>({
    loading: false,
    list: {} as IProjectTypeodel,
    ProjectTypeData: [] as IProjectTypeodel[],
    options: {
      chart: {
        width: 380,
        type: 'pie',
      },
      colors: [
        '#008FFB',
        '#00E396',
        '#FEB019',
        '#FF4560',
        '#775DD0',
        '#F28675',
        '#CEB019',
        '#E32E63',
      ],
      labels: lablesNames,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
    series: totalCnt,
  })

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        {/* begin::Title */}
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bolder fs-5 text-info'>
            {' '}
            <span className='text-success fs-5'>Gujarat </span>
            {'('} {monthName} {year} {')'} New Projects{' '}
            <span className='text-danger'> ({totalCount})</span>
          </span>
          {/* <span className='text-muted fw-bold fs-7'>More than 400 new members</span> */}
        </h3>
        {/* end::Title */}

        {/* begin::Toolbar */}
        {/* <div className='card-toolbar'> */}
        {/* begin::Menu */}
        {/* <button
            type='button'
            className='btn btn-sm btn-icon btn-color-primary btn-active-light-primary'
            data-kt-menu-trigger='click'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='top-end'
          >
            <KTSVG path='/media/icons/duotune/general/gen024.svg' className='svg-icon-2' />
          </button>
          <Dropdown1 /> */}
        {/* end::Menu */}
        {/* </div> */}
        {/* end::Toolbar */}
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body' style={{maxWidth: '100%', overflow: 'hidden'}}>
        {/* begin::Chart */}
        <div id='chart' style={{maxWidth: '150%', display: 'flex', justifyContent: 'center'}}>
          <ReactApexChart options={state.options} series={state.series} type='pie' width='134%' />
        </div>
        <div id='html-dist'></div>
        {/* <div ref={chartRef} id='kt_charts_widget_1_chart' style={{height: '350px'}} /> */}
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {StateGujaratPieChart}
